export default __webpack_public_path__ + "static/media/search.6fb8b667.svg";